"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptableInner = exports.Promptable = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var PromptContext_1 = require("Prompt/PromptContext");
var mobx_1 = require("mobx");
exports.Promptable = (0, mobx_react_1.observer)(function (props) { return (react_1.default.createElement(PromptContext_1.PromptConsumer, null, function (promptContext) {
    return promptContext ? (react_1.default.createElement(PromptableInner, __assign({}, props, { promptOrchestrator: promptContext.promptOrchestrator }))) : (props.children);
})); });
var PromptableInner = (function (_super) {
    __extends(PromptableInner, _super);
    function PromptableInner(props) {
        var _this = _super.call(this, props) || this;
        _this.promptableRef = react_1.default.createRef();
        return _this;
    }
    PromptableInner.prototype.render = function () {
        return (react_1.default.createElement("div", { ref: this.promptableRef, className: "promptable promptable--".concat(this.props.id) },
            this.props.children,
            this.promptableRef &&
                this.promptableRef.current &&
                this.props.promptOrchestrator.getPrompt(this.promptableRef, this.props.id)));
    };
    var _a;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof react_1.default !== "undefined" && react_1.default.RefObject) === "function" ? _a : Object)
    ], PromptableInner.prototype, "promptableRef", void 0);
    PromptableInner = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], PromptableInner);
    return PromptableInner;
}(react_1.default.Component));
exports.PromptableInner = PromptableInner;
